import React, { useState, useEffect } from 'react';
import { FlatList, View, Text, StyleSheet, BackHandler } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import ProgressCircle from 'react-native-progress-circle';
import LinearGradient from 'react-native-linear-gradient';
import TimeUtility from '../../utils/TimeUtility';
import FastImageView from '../FastImageView';
import { isPresent } from '../../utils/BooleanUtility';
import { getMinifiedImage } from '../../utils/ImageUtility';
import colors from '../../theme/Colors';
import { getScreenHeight, getScreenWidth } from '../../utils/LayoutUtility';

const JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;

const DefaultSizeSelfieList = (props) => {
  const { itemData = {} } = props;
  const [originalImg, setOriginalImg] = useState('');
  const [overAllScore, setOverAllScore] = useState();
  const [carouselData, setCarouselData] = useState([]);
  const navigation = useNavigation();
  const dateToShow = TimeUtility.getDayDateMonthYear(carouselData.created_at);

  let objectValue = [];

  const handleBackPress = () => {
    navigation.goBack();
    return true;
  };

  useEffect(() => {
    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      handleBackPress,
    );
    return () => {
      backHandler.remove();
    };
  }, []);

  useEffect(() => {
    if (isPresent(itemData)) {
      try {
        new JSONAPIDeserializer({
          typeAsAttribute: false,
          pluralizeType: true,
          keyForAttribute: 'snake_case',
        })
          .deserialize(itemData)
          .then((data) => {
            setOverAllScore(data?.skin_score);
            setOriginalImg(data?.image);
            setCarouselData(data);
          });
      } catch (e) {}
    } else {
      console.tron.log('Failed to Deserializer data');
    }
  }, [itemData]);

  if (isPresent(carouselData.orbo_data)) {
    objectValue = Object.entries(carouselData?.orbo_data)
      .map(([key, value]) => {
        return { ...value, name: key };
      })
      .filter((item) => item.score);
    const obj = {
      score: overAllScore,
      image_url: originalImg,
      type: 'overAllScore',
    };
    objectValue.splice(0, 0, obj);
  }

  const renderItem = ({ item }) => {
    const getProgressCircleColor = (severity) => {
      switch (severity) {
        case 2:
          return '#ff7171';
        case 1:
          return '#ffc800';
        default:
          return '#99c66c';
      }
    };
    return (
      <View style={[styles.imageContainer]}>
        <FastImageView
          source={{
            uri: getMinifiedImage(item?.image_url, styles.image.width),
          }}
          style={styles.image}
          resizeMode='cover'
        />
        <LinearGradient
          colors={['rgba(0, 0, 0, 0.6)', 'transparent']}
          style={styles.gradient}
        />
        <View style={styles.skinScoreContainer}>
          <Text style={styles.carouselText}>
            {item.analysis_attribute || 'Skin Score'}
          </Text>
          <ProgressCircle
            percent={item?.score}
            radius={20}
            borderWidth={3}
            color={getProgressCircleColor(item?.severity)}
            bgColor={colors.white}
            shadowColor={colors.white}
            outerCircleStyle={styles.outerCircleStyle}
          >
            <Text style={styles.scoreText}>{item?.score}%</Text>
          </ProgressCircle>
        </View>
      </View>
    );
  };
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.dateTextStyle}>AI analysis for {dateToShow}</Text>
        <Text style={styles.subTitleText}>
          Scroll right to see detailed analysis
        </Text>
      </View>
      <FlatList
        data={objectValue}
        horizontal
        renderItem={renderItem}
        keyExtractor={(item, index) => index.toString()}
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={styles.carousel}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: getScreenWidth(), 
    alignSelf:'center'
  },
  image: {
    width: 170,
    height: 250,
    borderRadius: 4,
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 6,
    borderColor: '#eaeaea',
    borderRadius: 4,
    alignSelf: 'center',
    borderWidth: 1,
    overflow: 'hidden',
    marginBottom: 24,
    marginTop: 4,
  },
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 60,
    zIndex: 1,
  },
  carousel: {
    paddingHorizontal: 12,
  },
  divider: {
    height: 1,
    width: 140,
    backgroundColor: 'black',
    marginVertical: 24,
    alignSelf: 'center',
  },
  dateTextStyle: {
    fontSize: 18,
    fontFamily: 'Roboto-Bold',
    color: '#000000',
    marginTop: 10,
  },
  textContainer: {
    left: 12,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  carouselText: {
    fontFamily: 'Roboto-Regular',
    color: '#ffffff',
    textAlign: 'center',
    fontWeight: '500',
  },
  scoreText: {
    fontFamily: 'Roboto-Regular',
    color: '#000000',
    textAlign: 'center',
    fontWeight: '500',
  },
  subTitleText: {
    fontFamily: 'Roboto-Regular',
    color: colors.subtitle,
    textAlign: 'center',
    fontWeight: '400',
    fontSize: 14,
    marginTop: 4,
  },
  skinScoreContainer: {
    position: 'absolute',
    top: 10,
    left: 10,
    right: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 2,
  },
  outerCircleStyle: {
    overflow: 'hidden'
  }
});

export default DefaultSizeSelfieList;
